module.exports = __webpack_public_path__ + "phabricator.b7cda6.svg";